export default "__VITE_ASSET__EfhBPyyr__"